(function () {
	  if (window.JSQSpecialtyMobileQuoteV1) return;
	  window.JSQSpecialtyMobileQuoteV1 = true;

	  var configs = {
	    boat: {
	      title: 'Boat quote',
	      kicker: 'Mobile boat detailing',
	      service: 'Boat Detailing',
	      unit: 'boat',
	      lengthId: 'boatLength',
	      exteriorId: 'boatExteriorService',
	      interiorId: 'boatInteriorService',
	      lengthPlaceholder: 'Example: 22',
	      helper: 'Enter the total length first. The price updates by the foot.',
	      exterior: [
	        { value: '10', label: 'Wash Only', summary: 'Mobile wash by linear foot.', price: '$10/ft' },
	        { value: '20', label: 'Wash & Wax', summary: 'Wash plus wax protection.', price: '$20/ft' },
	        { value: '50', label: 'Oxidation Removal', summary: 'Oxidation improvement and cleanup.', price: '$50/ft' },
	        { value: '0', label: 'No exterior service', summary: 'Use this for interior-only requests.', price: '$0' }
	      ],
	      interior: [
	        { value: '0', label: 'No interior cleaning', summary: 'Exterior only.', price: '$0' },
	        { value: '15', label: 'Interior / Cabin Cleaning', summary: 'Cabin or upholstery cleaning.', price: '$15/ft' },
	        { value: '25', label: 'Deep Interior / Upholstery', summary: 'Deeper cabin and upholstery work.', price: '$25/ft' },
	        { value: '35', label: 'Heavy Soil / Mildew / Odor', summary: 'Heavy condition quoted by foot.', price: '$35/ft' }
	      ]
	    },
	    rv: {
	      title: 'RV quote',
	      kicker: 'Mobile RV detailing',
	      service: 'RV Detailing',
	      unit: 'RV',
	      lengthId: 'rvLength',
	      exteriorId: 'rvExteriorService',
	      interiorId: 'rvInteriorService',
	      lengthPlaceholder: 'Example: 32',
	      helper: 'Enter the total RV length first. The price updates by the foot.',
	      exterior: [
	        { value: '10', label: 'Wash Only', summary: 'Exterior wash by linear foot.', price: '$10/ft' },
	        { value: '20', label: 'Wash & Wax', summary: 'Wash plus wax protection.', price: '$20/ft' },
	        { value: '50', label: 'Oxidation Removal', summary: 'Oxidation improvement and cleanup.', price: '$50/ft' },
	        { value: '0', label: 'No exterior service', summary: 'Use this for interior-only requests.', price: '$0' }
	      ],
	      interior: [
	        { value: '0', label: 'No interior cleaning', summary: 'Exterior only.', price: '$0' },
	        { value: '15', label: 'Interior Cleaning', summary: 'Living area or cockpit refresh.', price: '$15/ft' },
	        { value: '25', label: 'Deep Interior Cleaning', summary: 'Deeper RV interior clean.', price: '$25/ft' },
	        { value: '35', label: 'Heavy Soil / Odor / Pet Condition', summary: 'Heavy condition quoted by foot.', price: '$35/ft' }
	      ]
	    }
	  };

	  var state = {
	    kind: '',
	    length: '',
	    exterior: '10',
	    interior: '0',
	    formOpen: false
	  };

	  function byId(id) {
	    return document.getElementById(id);
	  }

	  function escapeHtml(value) {
	    return String(value || '').replace(/[&<>"']/g, function (char) {
	      return {
	        '&': '&amp;',
	        '<': '&lt;',
	        '>': '&gt;',
	        '"': '&quot;',
	        "'": '&#39;'
	      }[char];
	    });
	  }

	  function findOption(list, value) {
	    for (var i = 0; i < list.length; i += 1) {
	      if (String(list[i].value) === String(value)) return list[i];
	    }
	    return list[0];
	  }

	  function numberValue(value) {
	    var parsed = parseFloat(value || 0);
	    return isNaN(parsed) ? 0 : parsed;
	  }

	  function currentEstimate() {
	    var cfg = configs[state.kind];
	    if (!cfg) return null;
	    var exterior = findOption(cfg.exterior, state.exterior);
	    var interior = findOption(cfg.interior, state.interior);
	    var length = numberValue(state.length);
	    var rate = numberValue(exterior.value) + numberValue(interior.value);
	    var valid = length > 0 && rate > 0;
	    var total = Math.round(length * rate);
	    return {
	      cfg: cfg,
	      exterior: exterior,
	      interior: interior,
	      length: length,
	      rate: rate,
	      valid: valid,
	      total: total,
	      price: valid ? ('$' + total + '+ est.') : 'Enter length',
	      vehicle: length > 0 ? (length + ' ft ' + cfg.unit) : 'Enter length',
	      condition: exterior.label + ' + ' + interior.label,
	      addons: 'None'
	    };
	  }

	  function setText(id, value) {
	    var node = byId(id);
	    if (node && node.textContent !== value) node.textContent = value;
	  }

	  function setFieldValue(id, value) {
	    var field = byId(id);
	    if (field && field.value !== String(value)) field.value = String(value);
	  }

	  function syncLeadField(form, name, value) {
	    if (!form) return;
	    var input = form.querySelector('input[name="' + name + '"]');
	    if (!input) {
	      input = document.createElement('input');
	      input.type = 'hidden';
	      input.name = name;
	      input.setAttribute('data-jsq-specialty-mobile-lead-field', 'true');
	      form.appendChild(input);
	    }
	    input.value = value || '';
	  }

	  function smsHref(est) {
	    var message = 'Hi JS Mobile, I got an estimate: ' + est.price + ' - ' + est.cfg.service + ' / ' + est.vehicle + ' / ' + est.condition + '. Can you confirm it?';
	    return 'sms:+15098678979?&body=' + encodeURIComponent(message);
	  }

	  function syncFormAndSummary() {
	    var est = currentEstimate();
	    if (!est) return;

	    try {
	      window.jsqService = state.kind;
	      jsqService = state.kind;
	    } catch (error) {}

	    setFieldValue(est.cfg.lengthId, state.length);
	    setFieldValue(est.cfg.exteriorId, state.exterior);
	    setFieldValue(est.cfg.interiorId, state.interior);

	    setText('jsqPrice', est.price);
	    setText('jsqServiceText', est.cfg.service);
	    setText('jsqVehicleText', est.vehicle);
	    setText('jsqConditionText', est.condition);
	    setText('jsqAddonsText', est.addons);
	    setText('jsqRateBadge', 'Size-Based Estimate');
	    setText('jsqSmartMessage', est.valid ? 'Estimate ready. Final price and appointment window are confirmed by text before booking.' : 'Enter the length first, then choose exterior and interior options.');
	    setText('jsqValueNote', 'Final pricing depends on length, surface condition, access, and restoration level.');

	    var quoteDataText = est.cfg.service + ' | ' + est.vehicle + ' | ' + est.condition + ' | Add-ons: None | Estimated Total: ' + est.price + ' | Final price confirmed before booking';
	    var quoteData = byId('quoteData');
	    if (quoteData) quoteData.value = quoteDataText;

	    var form = byId('quoteRequestForm');
	    if (form) {
	      var priceNode = form.querySelector('[data-jsq-checkout-price]');
	      var serviceNode = form.querySelector('[data-jsq-checkout-service]');
	      var vehicleNode = form.querySelector('[data-jsq-checkout-vehicle]');
	      var conditionNode = form.querySelector('[data-jsq-checkout-condition]');
	      var addonsNode = form.querySelector('[data-jsq-checkout-addons]');
	      var smsNode = form.querySelector('[data-jsq-checkout-sms]');
	      if (priceNode) priceNode.textContent = est.price;
	      if (serviceNode) serviceNode.textContent = est.cfg.service;
	      if (vehicleNode) vehicleNode.textContent = est.vehicle;
	      if (conditionNode) conditionNode.textContent = est.condition;
	      if (addonsNode) addonsNode.textContent = est.addons;
	      if (smsNode) smsNode.href = smsHref(est);
	      syncLeadField(form, 'contact[Quote Price]', est.price);
	      syncLeadField(form, 'contact[Quote Service]', est.cfg.service);
	      syncLeadField(form, 'contact[Vehicle Type]', est.vehicle);
	      syncLeadField(form, 'contact[Vehicle Condition]', est.condition);
	      syncLeadField(form, 'contact[Selected Add-ons]', est.addons);
	      syncLeadField(form, 'contact[Booking Stage]', 'Specialty quote request - confirm price and appointment before booking');
	      syncLeadField(form, 'contact[Lead Source]', 'JS Mobile Detailing specialty mobile quote app');
	      syncLeadField(form, 'contact[Subject]', 'Quote request - ' + est.cfg.service + ' - ' + est.price);
	    }
	  }

	  function renderChoice(type, option) {
	    var activeValue = type === 'exterior' ? state.exterior : state.interior;
	    var active = String(activeValue) === String(option.value);
	    return '<button type="button" class="jsq-specialty-mobile-choice' + (active ? ' is-active' : '') + '" data-jsq-specialty-choice="' + type + '" data-value="' + escapeHtml(option.value) + '" aria-pressed="' + (active ? 'true' : 'false') + '">' +
	      '<span><strong>' + escapeHtml(option.label) + '</strong><small>' + escapeHtml(option.summary) + '</small></span>' +
	      '<em>' + escapeHtml(option.price) + '</em>' +
	      '</button>';
	  }

	  function renderChoices(type, list) {
	    return list.map(function (option) {
	      return renderChoice(type, option);
	    }).join('');
	  }

	  function ensureMount() {
	    var section = byId('jsqQuoteSection');
	    if (!section) return null;
	    var mount = byId('jsqSpecialtyMobileQuoteApp');
	    if (!mount) {
	      mount = document.createElement('div');
	      mount.id = 'jsqSpecialtyMobileQuoteApp';
	      mount.setAttribute('aria-live', 'polite');
	      var nativeApp = byId('jsqMobileQuoteApp');
	      section.insertBefore(mount, nativeApp || section.firstChild);
	    }
	    if (mount.dataset.jsqSpecialtyBound !== 'true') {
	      mount.dataset.jsqSpecialtyBound = 'true';
	      mount.addEventListener('click', function (event) {
	        var choice = event.target.closest && event.target.closest('[data-jsq-specialty-choice]');
	        var action = event.target.closest && event.target.closest('[data-jsq-specialty-action]');
	        if (!choice && !action) return;
	        event.preventDefault();
	        event.stopPropagation();
	        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

	        if (choice) {
	          var type = choice.getAttribute('data-jsq-specialty-choice');
	          var value = choice.getAttribute('data-value') || '0';
	          if (type === 'exterior') state.exterior = value;
	          if (type === 'interior') state.interior = value;
	          state.formOpen = false;
	          renderApp();
	          return;
	        }

	        if (action && action.getAttribute('data-jsq-specialty-action') === 'book') {
	          openForm();
	        }
	      }, true);

	      mount.addEventListener('input', function (event) {
	        var length = event.target && event.target.closest ? event.target.closest('[data-jsq-specialty-length]') : null;
	        if (!length) return;
	        state.length = length.value.replace(/[^\d.]/g, '');
	        state.formOpen = false;
	        paintDynamic();
	        syncFormAndSummary();
	      }, true);
	    }
	    return mount;
	  }

	  function renderApp() {
	    var cfg = configs[state.kind];
	    var mount = ensureMount();
	    if (!cfg || !mount) return;
	    var est = currentEstimate();
	    mount.innerHTML =
	      '<div class="jsq-specialty-mobile-top">' +
	        '<div><span class="jsq-specialty-mobile-kicker">' + escapeHtml(cfg.kicker) + '</span><strong class="jsq-specialty-mobile-title">' + escapeHtml(cfg.title) + '</strong></div>' +
	        '<b class="jsq-specialty-mobile-price" data-jsq-specialty-price>' + escapeHtml(est.price) + '</b>' +
	      '</div>' +
	      '<div class="jsq-specialty-mobile-steps" data-jsq-specialty-steps>' +
	        '<span class="jsq-specialty-mobile-step" data-jsq-specialty-step="length">Length</span>' +
	        '<span class="jsq-specialty-mobile-step" data-jsq-specialty-step="exterior">Exterior</span>' +
	        '<span class="jsq-specialty-mobile-step" data-jsq-specialty-step="interior">Interior</span>' +
	        '<span class="jsq-specialty-mobile-step" data-jsq-specialty-step="request">Request</span>' +
	      '</div>' +
	      '<div class="jsq-specialty-mobile-panel">' +
	        '<h3>1. Vehicle length</h3>' +
	        '<p class="jsq-specialty-mobile-help">' + escapeHtml(cfg.helper) + '</p>' +
	        '<div class="jsq-specialty-mobile-length"><input id="jsqSpecialtyLength" data-jsq-specialty-length type="number" min="1" step="1" inputmode="decimal" placeholder="' + escapeHtml(cfg.lengthPlaceholder) + '" value="' + escapeHtml(state.length) + '"><span>feet</span></div>' +
	      '</div>' +
	      '<div class="jsq-specialty-mobile-panel">' +
	        '<h3>2. Exterior level</h3>' +
	        '<p class="jsq-specialty-mobile-help">Start simple, then upgrade only if the surface needs more work.</p>' +
	        '<div class="jsq-specialty-mobile-choices">' + renderChoices('exterior', cfg.exterior) + '</div>' +
	      '</div>' +
	      '<div class="jsq-specialty-mobile-panel">' +
	        '<h3>3. Interior only if needed</h3>' +
	        '<p class="jsq-specialty-mobile-help">Leave this off for exterior-only service.</p>' +
	        '<div class="jsq-specialty-mobile-choices">' + renderChoices('interior', cfg.interior) + '</div>' +
	      '</div>' +
	      '<div class="jsq-specialty-mobile-summary">' +
	        '<h3>4. Review estimate</h3>' +
	        '<div class="jsq-specialty-mobile-total"><strong data-jsq-specialty-total>' + escapeHtml(est.price) + '</strong><span>No payment now</span></div>' +
	        '<div class="jsq-specialty-mobile-lines">' +
	          '<p><span>Service</span><b data-jsq-specialty-service>' + escapeHtml(cfg.service) + '</b></p>' +
	          '<p><span>Length</span><b data-jsq-specialty-vehicle>' + escapeHtml(est.vehicle) + '</b></p>' +
	          '<p><span>Detail level</span><b data-jsq-specialty-condition>' + escapeHtml(est.condition) + '</b></p>' +
	        '</div>' +
	        '<button type="button" class="jsq-specialty-mobile-action" data-jsq-specialty-action="book"' + (est.valid ? '' : ' disabled aria-disabled="true"') + '>Continue to contact info</button>' +
	        '<div class="jsq-specialty-mobile-fast-actions"><a href="tel:+15098678979">Call instead</a><a data-jsq-specialty-sms href="' + escapeHtml(smsHref(est)) + '">Text this quote</a></div>' +
	      '</div>';
	    paintDynamic();
	    syncFormAndSummary();
	  }

	  function paintDynamic() {
	    var est = currentEstimate();
	    if (!est) return;
	    var mount = byId('jsqSpecialtyMobileQuoteApp');
	    if (!mount) return;
	    var priceNodes = mount.querySelectorAll('[data-jsq-specialty-price], [data-jsq-specialty-total]');
	    priceNodes.forEach(function (node) {
	      if (node.textContent !== est.price) node.textContent = est.price;
	    });
	    var vehicleNode = mount.querySelector('[data-jsq-specialty-vehicle]');
	    var conditionNode = mount.querySelector('[data-jsq-specialty-condition]');
	    var bookButton = mount.querySelector('[data-jsq-specialty-action="book"]');
	    var smsNode = mount.querySelector('[data-jsq-specialty-sms]');
	    if (vehicleNode) vehicleNode.textContent = est.vehicle;
	    if (conditionNode) conditionNode.textContent = est.condition;
	    if (smsNode) smsNode.href = smsHref(est);
	    if (bookButton) {
	      bookButton.disabled = !est.valid;
	      bookButton.setAttribute('aria-disabled', est.valid ? 'false' : 'true');
	    }
	    var steps = mount.querySelectorAll('[data-jsq-specialty-step]');
	    steps.forEach(function (step) {
	      var key = step.getAttribute('data-jsq-specialty-step');
	      var lengthDone = est.length > 0;
	      var complete = (key === 'length' && lengthDone) || (key === 'exterior' && lengthDone) || (key === 'interior' && lengthDone) || (key === 'request' && state.formOpen);
	      var active = (!lengthDone && key === 'length') || (lengthDone && !state.formOpen && key === 'request') || (state.formOpen && key === 'request');
	      step.classList.toggle('is-complete', complete && !active);
	      step.classList.toggle('is-active', active);
	    });
	  }

	  function openForm() {
	    var est = currentEstimate();
	    var mount = byId('jsqSpecialtyMobileQuoteApp');
	    if (!est || !est.valid) {
	      var input = byId('jsqSpecialtyLength');
	      if (input) {
	        input.focus();
	        try {
	          input.scrollIntoView({ behavior: 'smooth', block: 'center' });
	        } catch (error) {
	          input.scrollIntoView();
	        }
	      }
	      return;
	    }

	    state.formOpen = true;
	    syncFormAndSummary();
	    paintDynamic();

	    var nativeApp = byId('jsqMobileQuoteApp');
	    var slot = byId('jsqMobileQuoteFormSlot');
	    var form = byId('quoteRequestForm');
	    if (nativeApp) nativeApp.classList.add('is-specialty-form-open');
	    if (slot && form && form.parentNode !== slot) slot.appendChild(form);
	    try {
	      window.dispatchEvent(new Event('jsq:simple-flow-book'));
	    } catch (error) {}
	    setTimeout(syncFormAndSummary, 80);
	    setTimeout(syncFormAndSummary, 260);
	    setTimeout(function () {
	      var target = slot || form || mount;
	      if (target) {
	        try {
	          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
	        } catch (error) {
	          target.scrollIntoView();
	        }
	      }
	      var first = form && form.querySelector('input[name="contact[name]"], input[type="text"], input[type="tel"], input[type="email"]');
	      if (first) {
	        try {
	          first.focus({ preventScroll: true });
	        } catch (error) {
	          first.focus();
	        }
	      }
	    }, 120);
	  }

	  function openSpecialtyQuote(kind) {
	    if (!configs[kind]) return;
	    state.kind = kind;
	    state.length = '';
	    state.exterior = '10';
	    state.interior = '0';
	    state.formOpen = false;

	    var section = byId('jsqQuoteSection');
	    if (!section) return;
	    section.classList.add('jsq-specialty-mobile-active');
	    section.classList.add('jsq-mobile-native-app');
	    var nativeApp = byId('jsqMobileQuoteApp');
	    if (nativeApp) {
	      nativeApp.classList.add('is-specialty-open');
	      nativeApp.classList.remove('is-specialty-form-open');
	    }

	    renderApp();
	    var mount = byId('jsqSpecialtyMobileQuoteApp');
	    setTimeout(function () {
	      if (mount) {
	        try {
	          mount.scrollIntoView({ behavior: 'smooth', block: 'start' });
	        } catch (error) {
	          mount.scrollIntoView();
	        }
	      }
	    }, 30);
	    setTimeout(function () {
	      var input = byId('jsqSpecialtyLength');
	      if (input) {
	        try {
	          input.focus({ preventScroll: true });
	        } catch (error) {
	          input.focus();
	        }
	      }
	    }, 260);
	  }

	  function linkKind(link) {
	    if (!link) return '';
	    if (link.closest('.jsq-specialty-seo--boat')) return 'boat';
	    if (link.closest('.jsq-specialty-seo--rv')) return 'rv';
	    var text = (link.textContent || '').trim();
	    if (/start\s+boat\s+quote/i.test(text)) return 'boat';
	    if (/start\s+rv\s+quote/i.test(text)) return 'rv';
	    return '';
	  }

	  window.JSQOpenSpecialtyQuote = openSpecialtyQuote;

	  document.addEventListener('click', function (event) {
	    var link = event.target && event.target.closest ? event.target.closest('a[href="#jsqQuoteSection"]') : null;
	    var kind = linkKind(link);
	    if (!kind) return;
	    event.preventDefault();
	    event.stopPropagation();
	    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
	    openSpecialtyQuote(kind);
	  }, true);

	  setInterval(function () {
	    if (!state.kind) return;
	    syncFormAndSummary();
	    paintDynamic();
	    var section = byId('jsqQuoteSection');
	    if (section) section.classList.add('jsq-specialty-mobile-active');
	    var nativeApp = byId('jsqMobileQuoteApp');
	    if (nativeApp && state.formOpen) nativeApp.classList.add('is-specialty-form-open');
	  }, 300);
	})();
